//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PDM.js";
import "../no/TransientObject.js";
let d=[[],[[[],"Dispose",{},0,0],[["nCriteria"],"NewFindcriteria",{R_:{findCriterias:"PDM.FindCriteria[]"}},1,0],[[],"NewDatabaseobjects",{R_:{databaseObjects:"PDM.DatabaseObjects"}},0,0],[["findCriterias"],"FindObjects",{R_:{databaseObjects:"PDM.DatabaseObjects[]"}},1,0],[["uId"],"GetDatabaseObjectFromAppSessionUid",{R_:{databaseObject:"PDM.DatabaseObject"}},1,0],[["designSessionParamNames","designSessionParamValues"],"FindDesignSessionObjects",{R_:{databaseObject:"PDM.DatabaseObject"}},2,0]],[]];
SPLM.PDM.DatabaseObjectManager = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PDM.DatabaseObjectManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;